<script lang="ts">
  export let size = '20';
</script>

<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.45837 9.99993L8.81671 12.3583L13.5417 7.6416"
    class={$$props.class || "stroke-garden-grey-900"}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
